import { Link } from 'react-router-dom'
import { motion } from 'motion/react'
import { ClientType } from '@/data/portfolio'

interface PortfolioCardProps {
  slug: string
  title: string
  description: string
  image: string
  clientTypes?: ClientType[]
  className?: string
}

export function PortfolioCard({ slug, title, description, image, className = '' }: PortfolioCardProps) {
  return (
    <motion.div
      className={`break-inside-avoid ${className}`}
      whileHover={{ y: -6 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      <Link to={`/portfolio/${slug}`} className="group block" aria-label={`View ${title} case study`}>
        <div className="bg-card border-border/50 overflow-hidden rounded-xl border">
          {/* Image with enforced aspect ratio */}
          <div className="aspect-[3/2] overflow-hidden">
            <img
              src={image}
              alt={title}
              width={600}
              height={400}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          {/* Text below image */}
          <div className="p-4">
            <h3 className="text-foreground group-hover:text-primary text-base leading-tight font-semibold transition-colors">
              {title}
            </h3>
            <p className="text-muted-foreground mt-2 line-clamp-2 hidden text-sm leading-relaxed md:block">
              {description}
            </p>
          </div>
        </div>
      </Link>
    </motion.div>
  )
}
